// External URLs
export const createAbsoluteUrl = (path: string = "") => {
	const baseUrl = "https://vlemobile.com"; // live url
	// const baseUrl = 'http://vle-next.appening.xyz'; // dev url
	return path ? `${baseUrl}/${path.replace(/^\//, "")}` : baseUrl;
};

export const constants = {
	skillsLevel: ["novice", "beginner", "skillfull", "experienced", "expert"],
	languageLevel: [
		{
			key: "elementary",
			value: "Working knowledge",
		},
		{
			key: "pre_intermediate",
			value: "Good working knowledge",
		},
		{
			key: "low_intermediate",
			value: "Very good command",
		},
		{
			key: "upper_intermediate",
			value: "Highly proficient",
		},
		{
			key: "advanced",
			value: "Native speaker",
		},
		{
			key: "a1",
			value: "A1",
		},
		{
			key: "a2",
			value: "A2",
		},
		{
			key: "b1",
			value: "B1",
		},
		{
			key: "b2",
			value: "B2",
		},
		{
			key: "c1",
			value: "C1",
		},
		{
			key: "c2",
			value: "C2",
		},
	],
};

export const individiualScoreOrder = [
	"jobTitle",
	"sector",
	"primarySkill",
	"secondarySkills",
	"technicalSkills",
	"experience",
	"degree",
	"certification",
	"preferredCompanies",
	"longevity",
	"gaps",
];

export const mapIndividualScore = {
	jobTitle: "Job Title Match",
	sector: "Sector Match",
	primarySkill: "Primary Skill Match",
	secondarySkills: "Secondary Skills Match (overall)",
	technicalSkills: "Technical Skills Match (overall)",
	experience: "Experience Match",
	degree: "Education Match",
	certification: "Certifications Match",
	preferredCompanies: "Preferred Companies Match",
	longevity: "Longevity Score",
	gaps: "Gaps Score",
};

export const keyToValueLanguage = {
	elementary: "Working knowledge",
	pre_intermediate: "Good working knowledge",
	low_intermediate: "Very good command",
	upper_intermediate: "Highly proficient",
	advanced: "Native speaker",
	a1: "A1",
	a2: "A2",
	b1: "B1",
	b2: "B2",
	c1: "C1",
	c2: "C2",
};

export const jdMatchStatus = {
	NA: 0,
	Sourced: 1,
	Interested: 2,
	"Not Interested": 3,
	"Good for Later": 4,
	Rejected: 5,
	Duplicate: 6,
	"Not Responding": 7,
	Submitted: 8,
	Interview: 9,
	Offered: 10,
};
